"use client";

import dynamic from "next/dynamic";

const DeveloperToolkitWidget = dynamic(() => import("./DeveloperToolkitWidget"), {
  ssr: false,
});

export default function DeveloperToolkitWidgetWrapper() {
  return <DeveloperToolkitWidget />;
}
